import React, { useCallback, useMemo, useState } from 'react'
import { Button, Classes, Tag } from '@blueprintjs/core'
import styled from 'styled-components'
import { useMutation, useQuery, useQueryClient } from 'react-query'
// import { TASKS_QUERY_FILTER } from 'ui-io/queries/tasks/tasks-query'
import { taskEventMutation } from 'ui-io/queries/tasks/task-event-mutation'
import {
  Box,
  InlineSpinnerIcon,
  ThemedDialog,
  useToggle,
} from 'ui-components'
import { delay } from 'ui-lib/delay'
import { TaskT } from 'ui-io/task-io/task-t'
// import { useSessionState } from '@maps-internal/neutron-react-client'
import useSession from 'ui-io/use-session'
import { useNavigate } from 'react-router-dom'
// import spectrumCheckResultsQuery from 'ui-io/queries/spectrum/spectrum-check-results-query'
// import jobRunResultsQuery from 'ui-io/queries/job-run-results-query'
// import configDiffQuery from 'ui-io/queries/config-diff-query'
// import {
//   templateList,
//   findFilteredPois,
//   templateKey,
// } from 'ui-components/src/pois-table/find-filtered-pois'
// import useParsedPois from 'ui-components/src/pois-table/use-parsed-pois'
// import plasmaAssetsSettingsQuery from 'ui-io/queries/plasma-assets/plasma-assets-settings-query'
import { IconNames } from '@blueprintjs/icons'

import toasts from '../../utils/toasts'
import {goToInbox} from '../../pages/tasks/go-to-inbox'
// import filterChecks from '../../pages/job-run-page/components/widgets/spectrum-widget/filter-checks'
import CloseTaskDialog from './close-task-dialog'
import ConfigDiffForm from '../../pages/task/config-diff-form'
import { TASKS_QUERY_FILTER } from 'ui-io/queries/tasks/task-query'
import { TASKS_SEARCH_QUERY } from 'ui-io/queries/tasks/tasks-query'

const PLASMA_ASSET_PATH = '/settings/'
const PLASMA_SETTINGS_KEY = 'validation-config'

const StartEditTaskButton = ({
  task,
  // testRunStatus,
}: {
  task: TaskT
  // testRunStatus?: string | null
}) => {
  // const { username } = useSessionState()
  const { session } = useSession()
  const username = session?.username || ''
  const [showDialog, toggleDialog] = useToggle(false)
  const [isJsonComparisonOpen, setJsonComparisonOpen] = useState(false)
  const [activeCloseModel, setCloseModel] = useState<boolean>(false)
  const { isInInbox, isRejectedByPublisher, assignee } = task
  const history = useNavigate()

  const queryClient = useQueryClient()
  // const lastTestRunId = task.lastTestRun?.run_id
  // const spectrumResults = useQuery(
  //   !lastTestRunId
  //     ? { enabled: false }
  //     : spectrumCheckResultsQuery(lastTestRunId),
  // )
  // const jobRunResults = useQuery(
  //   !lastTestRunId ? { enabled: false } : jobRunResultsQuery(lastTestRunId),
  // )
  // const poiValidationConfigConnection = useQuery(
  //   plasmaAssetsSettingsQuery(PLASMA_ASSET_PATH, PLASMA_SETTINGS_KEY),
  // )

  // const configDiffResults = useQuery(
  //   !task.id ? { enabled: false } : configDiffQuery(task.id),
  // )

  // const pois = useParsedPois(
  //   jobRunResults.data,
  //   poiValidationConfigConnection.data,
  //   task.configCountryCode,
  // )
  // const spectrumErrorCount = spectrumResults.isSuccess
  //   ? filterChecks(spectrumResults.data, {
  //       excludeSuccessfulChecks: true,
  //       excludeNonStoppers: true,
  //     }).length
  //   : 0

  // const spectrumWarningCount = spectrumResults.isSuccess
  //   ? filterChecks(spectrumResults.data, {
  //       excludeSuccessfulChecks: true,
  //       excludeStoppers: true,
  //     }).length
  //   : 0

  // const validationErrors = useMemo(() => {
  //   const defaultErrorMap = {} as Record<
  //     templateKey,
  //     { title: string; count: number }
  //   >
  //   return jobRunResults.isSuccess
  //     ? Object.entries(templateList).reduce((acc, [templateKey, meta]) => {
  //         const errorCount = findFilteredPois(templateKey as templateKey, pois)
  //           .pois.length
  //         if (errorCount) {
  //           acc[templateKey as templateKey] = {
  //             count: errorCount,
  //             title: meta.text,
  //           }
  //         }
  //         return acc
  //       }, defaultErrorMap)
  //     : defaultErrorMap
  // }, [jobRunResults.isSuccess, pois])

  const prepareNotes = () => {
    let comment: any = ''
    // if (configDiffResults.data && configDiffResults.data?.diff?.length > 4) {
    //   const [addCount, replaceCount, removeCount] = getConfigCount()
    //   comment = 'Config Changed\n\n'
    //   if (!!addCount) comment += `${addCount} Added\n`
    //   if (!!replaceCount) comment += `${replaceCount} Modified\n`
    //   if (!!removeCount) comment += `${removeCount} Removed\n`
    // } else if (
    //   configDiffResults.data &&
    //   configDiffResults.data?.diff?.length == 0
    // ) {
    //   comment = 'No Changes in Config'
    // } else if (
    //   configDiffResults.data &&
    //   configDiffResults.data?.diff?.length <= 4
    // ) {
    //   comment = configDiffResults.data?.diff.reduce((acc, item) => {
    //     if (item.op == 'add') acc += `Added at ${item.path}\n`
    //     else if (item.op == 'replace') acc += `Modified at  ${item.path}\n`
    //     else if (item.op == 'remove') acc += `Removed from ${item.path}\n`
    //     return acc
    //   }, 'Config Changed\n\n')
    // }
    if (comment.length < 15) return null
    return comment
  }

  const mutation = useMutation(
    async function ({ task }: { task: TaskT }) {
      if (!task.isInInbox) {
        throw new Error(`Cannot submit task in state "${task.state}"`)
      }
      // const notes = prepareNotes()
      const taskRequestObj: any = {
        taskId: task.id,
        eventType: 'IN_PROGRESS',
        user: task.assignee,
        updatedBy: username,
      }
      // if (notes) {
      //   taskRequestObj['properties'] = {
      //     comment: `Triggered event START_EDITING \n\n${notes}`,
      //   }
      // }
      await taskEventMutation(taskRequestObj)
    },
    {
      onError: (error) => {
        console.error(error)
        toasts.error(`Encountered an error when submitting a task`)
      },
      onSuccess: async () => {
        toasts.success(`Successfully moved ticket to In Progress`)
        await delay(500)
        queryClient.refetchQueries([TASKS_QUERY_FILTER])
        queryClient.refetchQueries([TASKS_SEARCH_QUERY]);
        goToInbox(history, { view: 'Create' })
      },
    },
  )

  const toggleCloseDialog = () => {
    setCloseModel(!activeCloseModel)
  }

  const submitHandler = async () => {
    mutation.mutateAsync({
      task,
    })
  }

  const disabled =  mutation.isLoading || username !== assignee
  const isConfigDiff = false
  // const isConfigDiff =
  //   configDiffResults.isSuccess && configDiffResults.data?.diff.length > 0
  const handleRequestNewTaskButtonClick = useCallback(async () => {
    if (disabled) {
      return
    }
    if (isConfigDiff) {
      setCloseModel(true)
    }
    // if (
    //   !!spectrumWarningCount ||
    //   !!spectrumErrorCount ||
    //   !!Object.values(validationErrors).length ||
    //   task.isMaintenanceTask
    // ) {
    //   toggleDialog()
    // } else {
      await mutation.mutateAsync({ task })
    // }
  }, [
    disabled,
    isConfigDiff,
    mutation,
    // spectrumErrorCount,
    // spectrumWarningCount,
    task,
    toggleDialog,
    // validationErrors,
  ])

  if (!isInInbox && !isRejectedByPublisher) {
    return null
  }

  const getConfigCount = () => {
    let addCount = 0
    let replaceCount = 0
    let removeCount = 0
    // if (configDiffResults.data && configDiffResults.data?.diff.length) {
    //   if (!!configDiffResults.data?.diff.length) {
    //     configDiffResults.data?.diff.filter((item) => {
    //       if (item.op == 'add') addCount++
    //       else if (item.op == 'replace') replaceCount++
    //       else if (item.op == 'remove') removeCount++
    //     })
    //   }
    // }
    return [addCount, replaceCount, removeCount]
  }
  const getConfigDiffBody = () => {
    const [addCount, replaceCount, removeCount] = getConfigCount()
    if (!!addCount || !!replaceCount || !!removeCount) {
      return (
        <>
          <p>
            The difference between <b>Prod</b> configuration and{' '}
            <b>Current Task</b> configuration are.
          </p>

          <ul>
            {!!addCount && <li>{addCount} Added</li>}
            {!!replaceCount && <li>{replaceCount} Replaced</li>}
            {!!removeCount && <li>{removeCount} Removed</li>}
          </ul>

          <div>
            <Button
              small
              minimal
              outlined
              intent={!isJsonComparisonOpen ? 'primary' : 'danger'}
              icon="comparison"
              onClick={() => setJsonComparisonOpen((p) => !p)}
            >
              {!isJsonComparisonOpen ? 'Show Diff' : 'Close Diff Box'}
            </Button>
            {isJsonComparisonOpen && (
              <ConfigDiffForm taskId={task.id} configId={task?.configUuid} />
            )}
          </div>
        </>
      )
    } else {
      return <></>
    }
  }
  const dialogBody = () => {
    if ( !isConfigDiff) {
      return (
        <div>
          There is no difference between <b>Prod</b> Data and{' '}
          <b>Current Task</b> Data.
          <br />
          <br />
          <p>Do you want to close the Task ?</p>
        </div>
      )
    } else {
      return (
        <div>
          Data generated from last run for this task has below issues.
          <br />
          {isConfigDiff && getConfigDiffBody()}
          <br />
          In case you have already verified the data, click on submit to
          proceed.
        </div>
      )
    }
  }
  return (
    <>
      <Button
        icon="arrow-right"
        onClick={handleRequestNewTaskButtonClick}
        disabled={disabled}
        intent="success"
      >
        {mutation.isLoading ? (
          <>
            Start Editing Task
            <Box mx="small" inline>
              <InlineSpinnerIcon />
            </Box>
          </>
        ) : (
          isRejectedByPublisher ? "Restart Edit" : "Start Edit"
        )}
      </Button>
      <CustomDialog
        isOpen={showDialog}
        title={`${isRejectedByPublisher ? "Restart": "Start"} Edit Task`}
        onClose={toggleDialog}
        icon={IconNames.ISSUE_CLOSED}
      >
        <div className={Classes.DIALOG_BODY}>{dialogBody()}</div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            { !isConfigDiff && (
              <Button
                onClick={() => {
                  toggleDialog()
                  toggleCloseDialog()
                }}
                disabled={disabled}
                intent="primary"
                icon={!isConfigDiff && 'delete'}
              >
                Close Task
              </Button>
            )}
            <Button
              onClick={submitHandler}
              disabled={disabled}
              intent="success"
            >
              Submit Task
            </Button>
            <Button aria-label="Close" onClick={toggleDialog}>
              Cancel
            </Button>
          </div>
        </div>
      </CustomDialog>
      { !isConfigDiff && (
        <CloseTaskDialog
          task={task}
          isModalOpen={activeCloseModel}
          toggleModal={toggleCloseDialog}
          isConfigDiff={true}
        />
      )}
    </>
  )
}
const CustomDialog = styled(ThemedDialog)`
  width: 50%;
`

export default StartEditTaskButton
